import React from "react";

const items = ["IPA", "STOUT", "LAGER", "PALE ALE", "PORTER", "PILSNER", "WEISSBIER", "AMBER", "BARLEYWINE", "GOLDEN ALE"];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-[#141414] py-4" data-testid="style-marquee">
      <div className="cg-marquee-track">
        {row.map((it, i) => (
          <span key={i} className="font-display text-2xl md:text-3xl text-gray-500 mx-6 flex items-center">
            {it}<span className="text-[#D97736] ml-6">•</span>
          </span>
        ))}
      </div>
    </div>
  );
};
